// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes MobileMenu_appear__gvYLp {
    from {
        opacity: 0;
        transform: translateY(40px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes MobileMenu_appearTablet__lPaTB {
    from {
        opacity: 0;
        transform: translateY(40px) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
    }
}

.MobileMenu_container__iEzyf {
    background-color: #111018;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 20px 20px 0 0;
    display: flex;
    flex-direction: column;
    z-index: 1000;
    padding: 20px;
    /* animation: appear 0.5s ease-out; */
}

.MobileMenu_menuItem__bd3Lm {
    background-color: #1d1c24;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border-radius: 12px;
    margin-bottom: 8px;
    gap: 6%;
}

.MobileMenu_menuItemText__l44ce {
    font-size: var(--font-size-7);
    font-family: var(--font-medium), sans-serif;
}

.MobileMenu_copyright__CDGbz {
    font-size: var(--font-size-4);
    color: #ffffff50;
    text-align: center;
    margin-top: 20px;
    font-family: var(--font-light), sans-serif;
    text-decoration: none;
}

@media (min-width: 577px) and (max-width: 992px) {
    .MobileMenu_container__iEzyf {
        position: fixed;
        bottom: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        border-radius: 20px;
        z-index: 1000;
        padding: 20px;
        animation: MobileMenu_appearTablet__lPaTB 0.5s ease-out;
    }
}

@media (min-width: 1024px) {
    .MobileMenu_container__iEzyf {
        position: fixed;
        bottom: 12%;
        left: 50%;
        transform: translateX(-50%);
        width: 68%;
        border-radius: 20px;
        z-index: 1000;
        padding: 20px;
        animation: MobileMenu_appearTablet__lPaTB 0.5s ease-out;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/MobileMenu/MobileMenu.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,aAAa;QACb,uDAAqC;IACzC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,aAAa;QACb,uDAAqC;IACzC;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateY(40px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes appearTablet {\n    from {\n        opacity: 0;\n        transform: translateY(40px) translateX(-50%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) translateX(-50%);\n    }\n}\n\n.container {\n    background-color: #111018;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 20px 20px 0 0;\n    display: flex;\n    flex-direction: column;\n    z-index: 1000;\n    padding: 20px;\n    /* animation: appear 0.5s ease-out; */\n}\n\n.menuItem {\n    background-color: #1d1c24;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    padding: 12px 20px;\n    border-radius: 12px;\n    margin-bottom: 8px;\n    gap: 6%;\n}\n\n.menuItemText {\n    font-size: var(--font-size-7);\n    font-family: var(--font-medium), sans-serif;\n}\n\n.copyright {\n    font-size: var(--font-size-4);\n    color: #ffffff50;\n    text-align: center;\n    margin-top: 20px;\n    font-family: var(--font-light), sans-serif;\n    text-decoration: none;\n}\n\n@media (min-width: 577px) and (max-width: 992px) {\n    .container {\n        position: fixed;\n        bottom: 10%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 95%;\n        border-radius: 20px;\n        z-index: 1000;\n        padding: 20px;\n        animation: appearTablet 0.5s ease-out;\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        position: fixed;\n        bottom: 12%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 68%;\n        border-radius: 20px;\n        z-index: 1000;\n        padding: 20px;\n        animation: appearTablet 0.5s ease-out;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileMenu_container__iEzyf`,
	"menuItem": `MobileMenu_menuItem__bd3Lm`,
	"menuItemText": `MobileMenu_menuItemText__l44ce`,
	"copyright": `MobileMenu_copyright__CDGbz`,
	"appearTablet": `MobileMenu_appearTablet__lPaTB`,
	"appear": `MobileMenu_appear__gvYLp`
};
export default ___CSS_LOADER_EXPORT___;
